import { type FC } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";

import { type BlastHitTarget, type BlastJob, type JobResult, JobStatusEnum } from "../../../graphql.js";
import { UNKNOWN_GENOME_NAME } from "../../../settings/settings.js";
import { GenericTile } from "../../core/tiles/index.js";

export interface IQueryInfoCardProps extends GridCard {
  job: BlastJob;
}

const QueryInfoCard: FC<IQueryInfoCardProps> = (props) => {
  const job: BlastJob = props.job;

  return (
    <Card shrinkable={job.results?.length > 7} key="job-status-info-card" title={"Queries"}>
      <CardRowSimple>
        {job.status === JobStatusEnum.Error
          ? "Job failed"
          : job.results.length === 0
            ? "Waiting for job to finish"
            : job.results.map((r: JobResult, idx: number) => {
                const bestHit: BlastHitTarget = r.blastHits?.length > 0 ? r.blastHits[0].target : null;
                let bestHitDesc = "No hits";

                if (bestHit != null) {
                  const version: string = bestHit?.version ? "." + bestHit.version : "";
                  const fromName: string =
                    bestHit && bestHit.organism === null && bestHit.database.mnemonic === null
                      ? bestHit.database.name // external hits
                      : bestHit.organism?.name !== UNKNOWN_GENOME_NAME
                        ? bestHit.organism?.name
                        : bestHit.database.mnemonic; // genomic hit or a internal hit in a non-genomic database
                  bestHitDesc = `Best hit: ${bestHit.accession}${version} ${
                    bestHit.name ? `(${bestHit.name})` : ""
                  } from ${fromName}`;
                }

                return (
                  <GenericTile
                    title={
                      r.query
                        ? `${r.query.accession}.${r.query.version}`
                        : "The query sequence is not available anymore"
                    }
                    to={`/job/${job.id}/results/${r.id}/summary`}
                    key={"ref-card-elem-query-" + idx}
                    footNote={bestHitDesc}
                  >
                    {r.query?.description}
                  </GenericTile>
                );
              })}
      </CardRowSimple>
    </Card>
  );
};

export default QueryInfoCard;
export { QueryInfoCard };
